import { getApiHost } from '../config';
import { getSignupMockl10n, getLoginMockl10n, getMockProviderInfo } from '../utils/getApiMockData';
import { getAcceptLanguage } from '../utils/Utils';

export const getSignupData = async (env, language, countryIso) => {
  const url = new URL(`${getApiHost(env)}/signup-component`);
  let l10n = {};

  try {
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        'X-Accept-Language': getAcceptLanguage(language, countryIso),
      },
      method: 'GET',
    });

    if (response.ok) {
      const json = await response.json();
      l10n = json.informationKeys;
    } else {
      throw new Error(response.status);
    }
  } catch (error) {
    console.log('Something went wrong when trying to fetch signup localization info.', error);

    if (env === 'local') {
      console.log('Fetching local data, rather than depending on API');
      l10n = getSignupMockl10n();
    }
  }

  return l10n;
};

export const getLoginData = async (env, language, countryIso, countryid) => {
  const url = new URL(`${getApiHost(env)}/login-component/${countryid}`);
  let l10n, providerInfo;

  try {
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        'X-Accept-Language': getAcceptLanguage(language, countryIso),
      },
      method: 'GET',
    });
    if (response.ok) {
      const json = await response.json();
      l10n = json.informationKeys;
      providerInfo = json.providerInfo;
    } else {
      throw new Error(response.status);
    }
  } catch (error) {
    console.log('Something went wrong when trying to fetch localization info.', error);

    if (env === 'local') {
      console.log('Fetching local data, rather than depending on API');
      l10n = getLoginMockl10n();
      providerInfo = getMockProviderInfo();
    }
  }
  return [l10n, providerInfo];
};
